import { useAtomValue } from 'jotai';
import { Fragment } from 'react';

import { useSequencerReadings } from '@/features/equipment-browser/equipment-details/hooks/use-sequencer-readings';
import {
  sequencesWithValuesAtom,
  SequenceWithValues,
} from '@/features/equipment-browser/equipment-details/state/sequencer-editor.state';

import { CondenserSequencerEditor } from './condenser-sequencer-editor';
import { CondenserSequencerInstructionsContent } from './condenser-sequencer-instructions-content';
import { SequencerInstructions } from '../components/sequencer-instructions';

/**
 * I've encountered issues where the ActiveSequence isn't actually the same as the key of the sequence.
 */
const checkIfSequenceIsActive = (
  sequenceWithValues: SequenceWithValues,
  activeSequenceValue: string
) => {
  return (
    sequenceWithValues.key?.replace(/_/g, '').toLowerCase() ===
    (activeSequenceValue as string)?.replace(/_/g, '').toLowerCase()
  );
};

export const CondenserSequencerEditorV2 = () => {
  const sequencesWithValues = useAtomValue(sequencesWithValuesAtom);
  const { activeSequenceValue } = useSequencerReadings();

  return (
    <Fragment key="condenser-sequencer-editor-v2">
      {sequencesWithValues
        .filter((sequence: SequenceWithValues) => sequence.value)
        .sort((a: SequenceWithValues, b: SequenceWithValues) => {
          return checkIfSequenceIsActive(a, activeSequenceValue as string)
            ? -1
            : checkIfSequenceIsActive(b, activeSequenceValue as string)
              ? 1
              : 0;
        })
        .map((sequenceWithValues: SequenceWithValues) => {
          const isActive = checkIfSequenceIsActive(
            sequenceWithValues,
            activeSequenceValue as string
          );
          return (
            <CondenserSequencerEditor
              isActive={isActive}
              key={sequenceWithValues.key}
              sequenceWithValues={sequenceWithValues}
              showActivityPill
            />
          );
        })}
      <SequencerInstructions id="condenser">
        <CondenserSequencerInstructionsContent />
      </SequencerInstructions>
    </Fragment>
  );
};
